export const normalisePageId = (id) => {
  // remove the first forwardslash if it exists
  if (id?.charAt(0) === '/') {
    id = id.substring(1);
  }

  return id.replace(/-/g, '_');
};

export const getPageUrlById = (id) => {
  return PAGES[id]?.base_url || '';
};

export const getPageIdByUrl = (url) => {
  for (const key in ALL_URLS) {
    if (ALL_URLS.hasOwnProperty.call(ALL_URLS, key)) {
      const element = ALL_URLS[key];

      if (element.includes(url)) {
        return key;
      }
    }
  }
};

export const PAGE_IDS = {
  home: 'homepage',
  terms: 'terms',
  cookie_policy: 'cookie_policy',
  privacy_policy: 'privacy_policy',
  about: 'about',
  characters: 'characters',
  explore_porthole: 'explore_porthole',
  vision_and_values: 'vision_and_values',
  character: 'character',
  location: 'location',
  make: 'make',
  watch: 'watch',
  gallery: 'gallery',
  games: 'games',
  game_matching_pairs: 'game_matching_pairs',
  game_bittern: 'game_bittern',
};

export const METADATA_CMS_IDS = {
  [PAGE_IDS.home]: 'homepage',
  [PAGE_IDS.terms]: 'terms',
  [PAGE_IDS.cookie_policy]: 'cookie_policy',
  [PAGE_IDS.privacy_policy]: 'privacy_policy',
  [PAGE_IDS.about]: 'about',
  [PAGE_IDS.characters]: 'characters',
  [PAGE_IDS.explore_porthole]: 'locations',
  [PAGE_IDS.vision_and_values]: 'vision_and_values',
  [PAGE_IDS.character]: 'character',
  [PAGE_IDS.location]: 'location',
  [PAGE_IDS.make]: 'make',
  [PAGE_IDS.watch]: 'watch',
  [PAGE_IDS.gallery]: 'gallery',
  [PAGE_IDS.games]: 'games',
  [PAGE_IDS.game_matching_pairs]: 'game_matching_pairs',
  [PAGE_IDS.game_bittern]: 'game_bittern',
};

export const ALL_URLS = {
  [PAGE_IDS.home]: '/',
  [PAGE_IDS.terms]: '/terms-of-use',
  [PAGE_IDS.cookie_policy]: '/cookie-policy',
  [PAGE_IDS.privacy_policy]: '/privacy-policy',
  [PAGE_IDS.about]: '/about',
  [PAGE_IDS.characters]: '/meet-the-characters',
  [PAGE_IDS.explore_porthole]: '/explore-porthole',
  [PAGE_IDS.vision_and_values]: '/vision-and-values',
  [PAGE_IDS.make]: '/activities',
  [PAGE_IDS.watch]: '/watch',
  [PAGE_IDS.gallery]: '/gallery',
  [PAGE_IDS.games]: '/games',
};

export const PAGES = {
  [PAGE_IDS.home]: {
    id: PAGE_IDS.home,
    name: 'Home',
    base_url: ALL_URLS[PAGE_IDS.home],
    metadata: {
      landing: METADATA_CMS_IDS[PAGE_IDS.home],
    },
  },
  [PAGE_IDS.about]: {
    id: PAGE_IDS.about,
    name: 'About',
    base_url: ALL_URLS[PAGE_IDS.about],
    metadata: {
      landing: METADATA_CMS_IDS[PAGE_IDS.about],
    },
  },
  [PAGE_IDS.characters]: {
    id: PAGE_IDS.characters,
    name: 'Characters',
    base_url: ALL_URLS[PAGE_IDS.characters],
    metadata: {
      landing: METADATA_CMS_IDS[PAGE_IDS.characters],
      subpage: METADATA_CMS_IDS[PAGE_IDS.character],
    },
  },
  [PAGE_IDS.explore_porthole]: {
    id: PAGE_IDS.explore_porthole,
    name: 'Exploe Porthole',
    base_url: ALL_URLS[PAGE_IDS.explore_porthole],
    metadata: {
      landing: METADATA_CMS_IDS[PAGE_IDS.explore_porthole],
      location: METADATA_CMS_IDS[PAGE_IDS.location],
    },
  },
  [PAGE_IDS.vision_and_values]: {
    id: PAGE_IDS.vision_and_values,
    name: 'Vision and Values',
    base_url: ALL_URLS[PAGE_IDS.vision_and_values],
    metadata: {
      landing: METADATA_CMS_IDS[PAGE_IDS.vision_and_values],
    },
  },
  [PAGE_IDS.terms]: {
    id: PAGE_IDS.terms,
    name: 'Terms and Conditions',
    base_url: ALL_URLS[PAGE_IDS.terms],
    metadata: {
      landing: METADATA_CMS_IDS[PAGE_IDS.terms],
    },
  },
  [PAGE_IDS.cookie_policy]: {
    id: PAGE_IDS.cookie_policy,
    name: 'Cookie Policy',
    base_url: ALL_URLS[PAGE_IDS.cookie_policy],
    metadata: {
      landing: METADATA_CMS_IDS[PAGE_IDS.cookie_policy],
    },
  },
  [PAGE_IDS.privacy_policy]: {
    id: PAGE_IDS.privacy_policy,
    name: 'Privacy Policy',
    base_url: ALL_URLS[PAGE_IDS.privacy_policy],
    metadata: {
      landing: METADATA_CMS_IDS[PAGE_IDS.privacy_policy],
    },
  },
  [PAGE_IDS.make]: {
    id: PAGE_IDS.make,
    name: 'Make',
    base_url: ALL_URLS[PAGE_IDS.make],
    metadata: {
      landing: METADATA_CMS_IDS[PAGE_IDS.make],
    },
  },
  [PAGE_IDS.watch]: {
    id: PAGE_IDS.watch,
    name: 'watch',
    base_url: ALL_URLS[PAGE_IDS.watch],
    metadata: {
      landing: METADATA_CMS_IDS[PAGE_IDS.watch],
    },
  },
  [PAGE_IDS.gallery]: {
    id: PAGE_IDS.gallery,
    name: 'Gallery',
    base_url: ALL_URLS[PAGE_IDS.gallery],
    metadata: {
      landing: METADATA_CMS_IDS[PAGE_IDS.gallery],
    },
  },
  [PAGE_IDS.games]: {
    id: PAGE_IDS.games,
    name: 'Games',
    base_url: ALL_URLS[PAGE_IDS.games],
    metadata: {
      landing: METADATA_CMS_IDS[PAGE_IDS.games],
    },
  },
};
